<template>
  <div class="select-box">
    <div class="quick-select">
      <div class="select-item" @click="dateItem('TODAY')">
        <span class="data-time" :class="checkData==='TODAY'?'select-item-active':''">今日</span>
      </div>
      <div class="select-item border-left"  @click="dateItem('YESTERDAY')">
        <span class="data-time"  :class="checkData==='YESTERDAY'?'select-item-active':''">昨日</span>
      </div>
      <div class="select-item border-left"  @click="dateItem('LAST_7_DAYS')">
        <span class="data-time"  :class="checkData==='LAST_7_DAYS'?'select-item-active':''">最近7天</span>
      </div>
      <div class="select-item border-left"  @click="dateItem('LAST_30_DAYS')">
        <span class="data-time"  :class="checkData==='LAST_30_DAYS'?'select-item-active':''">最近30天</span>
      </div>
    </div>
    <div class="time-select">
      <el-date-picker
        v-model="selectTime"
        type="daterange"
        size="small"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="changeDuringTime"
      >
      </el-date-picker>
    </div>
    <div class="member-select" v-if="tabName!=='GROUP_SEND_TASK'">
      <el-button @click="openMember" plain>
        <span v-show="memberName.length===0&&tabName!=='GROUP_CHAT'">选择部门/成员</span>
        <span v-show="memberName.length===0&&tabName==='GROUP_CHAT'">选择群主</span>
        <span v-show="memberName.length >0" v-for="(item,index) in memberName">
          {{index===0?item.name:','+item.name}}
        </span>
      </el-button>
    </div>
    <el-dialog
      title="选择部门/成员"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="50%">
      <div class="select-member">
        <div class="department-list">
          <el-input
            placeholder="输入关键字进行过滤"
            size="small"
            v-model="filterText">
          </el-input>
          <el-tree
            class="filter-tree"
            node-key="id"
            :data="memberList"
            :props="defaultProps"
            show-checkbox
            :check-strictly="true"
            ref="tree"
            @check-change="changeTreeData"
            :filter-node-method="filterNode"
          >
          </el-tree>
        </div>
        <div class="selected-list">
          <div class="selected-title">已选择的部门或成员</div>
          <div class="selected-item" v-for="member in checkMember" :key="member.id">
            <div class="item-name">
              <i class="arsenal_icon arsenalsitemap1" v-if="!member.isMember"></i>
              <i class="arsenal_icon arsenaluser1" v-if="member.isMember"></i>
              {{member.name}}
            </div>
            <div class="item-remove" @click="deleteCheckMember(member.id)"><i class="el-icon-close"></i></div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmMember">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
    data(){
        return{
            selectTime: '',
            dialogVisible: false,
            filterText: '',
            data: [{
              id: 1,
              label: '一级 1',
              children: [{
                id: 4,
                label: '二级 1-1',
                children: [{
                  id: 9,
                  label: '三级 1-1-1'
                }, {
                  id: 10,
                  label: '三级 1-1-2'
                }]
              }]
            }, {
              id: 2,
              label: '一级 2',
              children: [{
                id: 5,
                label: '二级 2-1'
              }, {
                id: 6,
                label: '二级 2-2'
              }]
            }, {
              id: 3,
              label: '一级 3',
              children: [{
                id: 7,
                label: '二级 3-1'
              }, {
                id: 8,
                label: '二级 3-2'
              }]
            }],
            defaultProps: {
              children: 'children',
              label: 'name'
            },
            memberList:[],
           checkMember:[],
          memberFilters:[],
          checkData:'',
          memberName:[],
          taskPage:1,
          taskList:[],
          taskPageSize:20
        }
    },
  props:['tabName'],
  mounted() {
      console.log(this.memberList)
  },
  watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
    methods:{
      openMember(){
        this.dialogVisible = true
        console.log(this.memberList,this.memberName)
        this.$nextTick(()=>{
          let ids = this.memberName.length >0?this.memberName.map(item=>item.id):[]
          this.$refs.tree.setCheckedKeys(ids)
        })
      },
      deleteCheckMember(id){
        for (let i=0;i<this.checkMember.length;i++){
          if (id===this.checkMember[i].id){
            this.checkMember.splice(i,1)
          }
        }
        let ids = this.checkMember.length >0?this.checkMember.map(item=>item.id):[]
        this.$refs.tree.setCheckedKeys(ids)
      },
      confirmMember(){
        this.dialogVisible = false
        let memberFilters = this.checkMember.length > 0 ?this.checkMember.map((res)=>{
          let info ={
            type:res.isMember?'MEMBER':'DEPARTMENT',
            userId:res.id
          }
          return info
        }):[]
        console.log(memberFilters)
        this.memberFilters=memberFilters

        this.memberName=this.checkMember.length > 0 ?this.checkMember:[]

        this.$emit('confirmMember',this.memberFilters)
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.name.indexOf(value) !== -1;
      },
      //获取员工
      getMember(){
        let url = '/scrm-api/we-work/member'
        this.$http.get(url).then(res => {
          console.log(res)
          if (res.status === 200) {
            this.memberList = res.data
            console.log(this.memberList)
          }
        })
      },
      changeTreeData(){
        console.log(this.$refs.tree.getCheckedNodes())
        let node = this.$refs.tree.getCheckedNodes()
        this.checkMember=node

      },
      dateItem(data){
        this.$emit('dateItem',data)
        this.checkData=data
      },
      changeDuringTime(){
        if (this.selectTime){
          let d = this.selectTime[0]
          let startTimeDated = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
          let startTimeDate = new Date(Date.parse(startTimeDated.replace(/-/g, "/")));
          let startTime = startTimeDate.getTime();
          let end = this.selectTime[1]
          let e = new Date(end)
          let endday = e.getFullYear() + '-' + (e.getMonth() + 1) + '-' + e.getDate()
          let timestamp = (new Date()).getTime();
          let yy = new Date().getFullYear();
          let mm = new Date().getMonth() + 1;
          let dd = new Date().getDate();
          let today = yy+"-"+mm+"-"+dd;
          let todaystamp = Date.parse(today);
          let enddaystamp = Date.parse(endday);
          let endTime = '';
          console.log(todaystamp,enddaystamp)
          if(todaystamp === enddaystamp){
            endTime =  timestamp
          }
          else{
            let endTimeDated = e.getFullYear() + '-' + (e.getMonth() + 1) + '-' + e.getDate() + ' ' + '23:59:59';
            let endTimeDate = new Date(Date.parse(endTimeDated.replace(/-/g, "/")));
            endTime = endTimeDate.getTime();
          }
          console.log(startTime,endTime)
          if(startTime > timestamp || endTime > timestamp){
            this.selectTime = [];
            this.$message.error('不能穿越哦，请重新选择：');
          }
          this.$emit('changeDuringTime','DURATION',startTime,endTime)
        }
        else {
          this.$emit('changeDuringTime','DURATION',0,0)
        }
      },
    }
};
</script>

<style lang="less" scoped>
.select-box{
    display: flex;
    flex-direction: row;
    align-items: center;
    .quick-select{
       display: flex;
       flex-direction: row;
       border: 1px solid #DCDFE6;
       height: 30px;
       line-height: 30px;
       border-radius: 4px;
       margin-right: 20px;
       .data-time{
         padding: 0px 20px;
         color: #909399;
         cursor: pointer;
       }
      .data-time:hover{
        color: white;
      }
      .select-item:hover{
        background-color: #409eff;
        color: #ffffff;
      }
      .select-item-active{
        background-color: #409eff;
        color: #ffffff;
      }
       .border-left{
         border-left: 1px solid #DCDFE6;
       }
       .border-right{
         border-left: 1px solid #DCDFE6;
       }
    }
    .time-select{
      .el-input__inner{
        height: 30px !important;
        line-height: 30px !important;
      }
    }
    .member-select{
      margin: 0px 10px;
      .el-button{
        padding: 7px 20px;
      }
    }
    .select-member{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      height: 50vh;
      overflow-x: hidden;
      overflow-y: auto;
      .department-list{
        width: 58%;
        padding: 0px 10px;
      }
      .filter-tree{
        margin-top: 10px;
      }
      .selected-list{
        width: 42%;
        border-left: 1px solid #dddddd;
        padding: 0px 14px;
        .selected-title{
          margin: 0px 0px 20px 0px;
        }
        .selected-item{
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          margin: 10px 0px;
          .item-name{
            i{
              margin-right: 10px;
            }
          }
          .item-remove{
            color: #909399;
            cursor: pointer;
          }
        }
      }
    }

}
</style>